import React, { Component } from 'react'
import './Main.css'
import '../MainPanel.css'
// import SideNav from "../sidenav/SideNav";
import SideNav from '../sidenav/Sidenav'

import { CrfContext } from '../../CrfContext'
import redAssetLogo from '../../images/redassetmegawide.PNG'
import { Transition, animated } from 'react-spring/renderprops'

export class Main extends Component {
  state = {
    showContent: true
  }

  componentDidMount () {
    // document.getElementById('mainPanel').style.background = '#ee3124'
  }

  render () {
    return (
      <CrfContext.Consumer>
        {context => (
          <div id='mainPage'>
            <div id='sidePanel'>
              <SideNav
                testState={context.state.testState}
                toggleBtn1List={context.toggleBtn1List}
                toggleBtn2List={context.toggleBtn2List}
                btn1List={context.state.btn1List}
                btn2List={context.state.btn2List}
                userRole={context.state.userRole}
              />
            </div>
            <div id='mainPanel'>
              {/* <h1>Create Request</h1> */}
              <Transition
                native
                items={this.state.showContent}
                from={{ opacity: 0 }}
                enter={{ opacity: 1 }}
                leave={{ opacity: 0 }}
                config={{ duration: 1000 }}
              >
                {show =>
                  show &&
                  (props => (
                    <animated.div style={props}>
                      <div className='homePagePanel'>
                        <h1 className='homePageTitle'>
                          CHECK REQUEST <br />
                          AND INQUIRY SYSTEM
                        </h1>
                        <span className='homePageRedLine'></span>
                        <img
                          className='homePageAssetLogo'
                          src={redAssetLogo}
                          alt=''
                        />
                      </div>
                    </animated.div>
                  ))
                }
              </Transition>
            </div>
          </div>
        )}
      </CrfContext.Consumer>
    )
  }
}

export default Main
